
// SVG Icon: ar-realign
export default { id: "terriajs-ar-realign" };
export const id = "terriajs-ar-realign";
export const name = "ar-realign";
